import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Sidebar from "../../comman_page/Sidebar";
import { HeaderDashboard } from "../../comman_page/HeaderDashboard";
import { Footer } from "../../../../../public/containers/footer/Footer";
import { Row, Col, Container, Form, Spinner } from "react-bootstrap";
import { InputField } from "../../../../../sharedComponents/InputField";
import { SharedSelect } from "../../../../../sharedComponents/SharedSelect";
import { MyDatePicker } from "../../../../../sharedComponents/MyDatePicker";
import { TextArea } from "../../../../../sharedComponents/TextArea";
import { SharedButton } from "../../../../../sharedComponents/Button";
import { check_pass_editable, get_pass_details, get_pass_type, update_passes } from "../../../../../Studio-Services/Studio_Services";
import moment from "moment";
import { SharedMultiSelect } from "../../../../../sharedComponents/SharedMultiSelect";
import Swal from "sweetalert2";
import logo from "../../../../../Images/logo_white_web.png"
import { InputTypeTax } from "../../../../../sharedComponents/InputTypeTax";
import { yesNoOption } from "../../../../../sharedComponents/MyHelperFunction";
import Tooltips from "../../../../../client-staff/Components/CommanPages/Tooltips";
import { errorAlert, infoAlert } from "../../../../../Static_Services/Alertmsg";

export const PassUpdateNew = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const [searchTitle, setSearchTitle] = useState();
    const [classes, setClasses] = useState();
    const [showEXP, setShowEXP] = useState();
    const [classOption, setClassOption] = useState([]);
    const [skillsdata, setSkillsdata] = useState();
    const [showRenew, setShowRenew] = useState();
    const [isAutoAdd, setIsAutoAdd] = useState(false);
    const [loader, setLoader] = useState(false);
    const [newDate, setNewDate] = useState();

    const [checkIsPurchase, setCheckIsPurchase] = useState(false);


    const opyesno = [
        { value: "yes", label: <>Yes</> },
        { value: "no", label: <>No</> },
    ]

    const statusOption = [
        { value: "Active", label: <>Active</> },
        { value: "Deactive", label: <>Inactive</> },
    ]

    const ageOPT = [
        { value: "Over", label: <>Over </> },
        { value: "Under", label: <>Under </> },
        { value: "None", label: <>None </> },
    ]

    const [prd, setPrd] = useState(
        {
            pass_name: "", pass_type: "", pass_sub_type: "", purchase_date: "", passexpiry: "", tax1: "", tax2: "",
            tax1_rate: "", tax2_rate: "", amount: "", is_client_visible: "", is_one_time_purchase: "", description: "",
            notes: "", age_restriction: "", age_over_under: "", class_details: "", all: '', 'is_recurring_billing': '', autoAdd: "No", pass_status: "Active"
        }
    );
    const [error, setError] = useState(
        {
            pass_name: "", pass_type: "", pass_sub_type: "", purchase_date: "", passexpiry: "", tax1: "", tax2: "",
            tax1_rate: "", tax2_rate: "", amount: "", is_client_visible: "", is_one_time_purchase: "", description: "",
            notes: "", age_restriction: "", age_over_under: "", class_details: "", autoAdd: '', pass_status: ""
        }
    )


    const getPassDetails = async (id) => {
        const finalData = { pass_id: id }
        const resp = await get_pass_details(finalData);
        if (resp) {
            setClasses(resp.data.data);
        }
    }

    const passEditableHandler = async (id) => {
        const payload = { pass_id: id };
        try {
            setLoader(true);
            const resp = await check_pass_editable(payload);
            // If API returns a positive count, mark as purchased
            if (resp?.data && parseInt(resp.data) > 0) {
                setCheckIsPurchase(true);
            } else {
                setCheckIsPurchase(false);
            }
        } catch (error) {
            console.log('@Console Error-- ', error);
        } finally {
            setLoader(false);
        }
    };



    useEffect(() => {
        if (location && location.state && location.state.data) {
            const pd = location.state.data;

            if (pd && pd.pass_id) { passEditableHandler(pd.pass_id); }

            setPrd(
                {
                    pass_name: pd.pass_name, pass_type: (pd?.is_recurring_billing === 'yes' && pd?.pass_type === "Punch Card") ? 'Recurring Punch Card' : pd.pass_type, pass_sub_type: pd.pass_sub_type, purchase_date: pd.purchase_date, passexpiry: pd.pass_validity, tax1: pd.tax1, tax2: pd.tax2,
                    tax1_rate: pd.tax1_rate, tax2_rate: pd.tax2_rate, amount: pd.amount, is_client_visible: pd.is_client_visible, is_one_time_purchase: pd.is_one_time_purchase, description: pd.description,
                    notes: pd.notes, age_restriction: pd.age_restriction, age_over_under: pd.age_over_under, class_details: "", all: pd, is_recurring_billing: pd.is_recurring_billing, autoAdd: pd?.isAutoAdd, pass_status: pd?.pass_status
                }
            )

            if (pd?.amount !== undefined && parseFloat(pd.amount) === 0) {
                setIsAutoAdd(true)
            } else if (pd?.amount !== undefined && parseFloat(pd.amount) > 0) {
                setIsAutoAdd(false)
            }

            if (pd && pd.pass_type == "Time Frame") {
                setSearchTitle(<>Number Of Days</>);
                setPrd((pre) => ({ ...pre, pass_sub_type: pd.pass_days }));
                setShowEXP(pd.pass_type);
            } else if (pd && pd.pass_type == "Punch Card") {
                setSearchTitle(<>Number Of Classes</>);
                setPrd((pre) => ({ ...pre, pass_sub_type: pd.pass_days }));
                if (pd?.is_recurring_billing == 'yes') {
                    setShowEXP();
                    setShowRenew('show');
                } else {
                    setShowRenew();
                    setShowEXP(pd.pass_type);
                }
            } else if (pd && pd.pass_type == "Recurring Membership") {
                setSearchTitle(<>Number Of Month</>);
            }
            getPassDetails(pd.pass_id)
        }
    }, [location])

    const onHandler = (e) => {
        const { name, value } = e.target;
        if (name == 'tax1_rate') {
            let cleanedValue = value.replace(/\s+/g, "");   // remove all spaces
            cleanedValue = cleanedValue.replace(/^0+/, "");
            setPrd((pre) => ({ ...pre, [name]: cleanedValue }));
            setError((pre) => ({ ...pre, [name]: '' }));

        } else if (name == 'tax2_rate') {
            let cleanedValue = value.replace(/\s+/g, "");   // remove all spaces
            cleanedValue = cleanedValue.replace(/^0+/, "");
            setPrd((pre) => ({ ...pre, [name]: cleanedValue }));
            setError((pre) => ({ ...pre, [name]: '' }));

        } else {
            setPrd((pre) => ({ ...pre, [name]: value }));
            setError((pre) => ({ ...pre, [name]: '' }));
        }
    }

    const submitHandler = async (e) => {
        e.preventDefault();

        const date_new = moment(newDate).unix();


        let isValid = 1;
        let ownpassexpiry = 30;
        let tax1Rate = 0;
        let tax2Rate = 0;
        const class_details = [];
        if (skillsdata) { skillsdata.map((e) => { class_details.push(e.value,) }) }

        if (!prd.pass_name) { setError((pre) => ({ ...pre, pass_name: "* Required" })); isValid = 2 }
        if (!prd.tax1) { setError((pre) => ({ ...pre, tax1: "* Required" })); isValid = 5 }
        if (!prd.is_client_visible) { setError((pre) => ({ ...pre, is_client_visible: "* Required" })); isValid = 9 }
        if (!prd.description) { setError((pre) => ({ ...pre, description: "* Required" })); isValid = 10 }
        if (!prd.notes) { setError((pre) => ({ ...pre, notes: "* Required" })); isValid = 11 }



        if ((prd.tax1).toLowerCase() == "yes") {
            if (!prd.tax1_rate) { setError((pre) => ({ ...pre, tax1_rate: "* Required" })); isValid = 6 }
            tax1Rate = prd.tax1_rate;
        }
        if (!prd.tax2) { setError((pre) => ({ ...pre, tax2: "* Required" })); isValid = 7 }
        if ((prd.tax2).toLowerCase() == "yes") {
            if (!prd.tax2_rate) { setError((pre) => ({ ...pre, tax2_rate: "* Required" })); isValid = 8 }
            tax2Rate = prd.tax2_rate;
        }
        if ((prd.tax1).toLowerCase() == "no") {
            if (!prd.tax2_rate) { setError((pre) => ({ ...pre, tax2_rate: "* Required" })); isValid = 8 }
            tax1Rate = 0;
        }
        if ((prd.tax2).toLowerCase() == "no") {
            if (!prd.tax2_rate) { setError((pre) => ({ ...pre, tax2_rate: "* Required" })); isValid = 8 }
            tax2Rate = 0;
        }

        if (isValid === 1) {
            setLoader(true);
            const payload = {
                'pass_id': prd.all.pass_id,
                'pass_name': prd.pass_name,
                'tax1': prd.tax1,
                'tax1_rate': tax1Rate || 0,
                'tax2': prd.tax2,
                'tax2_rate': tax2Rate || 0,
                'is_client_visible': prd.is_client_visible,
                'pass_status': prd.pass_status,
                'description': prd.description,
                'notes': prd.notes,
                'class_details': class_details,
                'isAutoAdd': prd?.autoAdd,
                'purchase_date': date_new,
                'pass_validity': prd?.passexpiry
            }
            const resp = await update_passes(payload);
            if (resp) {
                setLoader(false);
                Swal.fire({
                    html: `
                    <img src=${logo} class="img-fluid d-block mx-auto mt-5" />
                    <h4 class="title text-capitalize text-center mt-4 textWhite">
                      SUCCESS
                    </h4>
                    <p class="text-center my-4 textcolor">
                      <small class="textWhite">
                        ${resp.data.message}
                      </small>
                    </p>
                  `,
                    showClass: {
                        popup: 'custom-dialog-container',
                    },
                    customClass: {
                        confirmButton: 'custom-button custom-button-size modalbtn',
                    },
                }).then((result) => {
                    if (result.isConfirmed) {
                        navigate("/list-pass");
                    }
                });
            } else {
                setLoader(false);
            }
        }
        setLoader(false);

    }


    const optClasses = () => {
        const abc = [];
        if (classes && classes.class) {
            (classes.class).map((e) => {
                abc.push({ value: e.id, label: e.class_name })
            })
        }
        setClassOption(abc);
    }


    useEffect(() => {
        if (classes && classes.class) { optClasses(); }
    }, [classes])


    return (
        <>
            {loader && <div className='MainLoader'><Spinner animation="border" role="status" className='Loader'></Spinner></div>}
            <div className="MainDashboard">
                <div className="MainLayout">
                    <Row>
                        <Sidebar />
                        <Col className="p-0 RightCol">
                            <div className="RightSide">
                                <HeaderDashboard />
                                <div className="innerContent">
                                    <div className="AddPassContent">
                                        <Container>
                                            <Form onSubmit={submitHandler} autoComplete='off'>
                                                <h3 className="mb-5 mt-3">EDIT PASS</h3>
                                                <Row className="m-0 p-0">
                                                    <Col className='col-4 col-md-4 col-lg-4 mt-3'>
                                                        <InputField
                                                            type={"text"}
                                                            name={"pass_name"}
                                                            value={prd.pass_name}
                                                            error={error.pass_name}
                                                            onChange={onHandler}
                                                            lable={"Pass Name"} />
                                                    </Col>
                                                    <Col className='col-4 col-md-4 col-lg-4 mt-3'>
                                                        <InputField
                                                            type={'text'}
                                                            value={prd.pass_type}
                                                            name={"pass_type"}
                                                            readOnly={true}
                                                            lable={"Type of Pass"} />
                                                    </Col>
                                                    {searchTitle ?
                                                        <Col className='col-4 col-md-4 col-lg-4 mt-3'>
                                                            <InputField
                                                                name={"pass_sub_type"}
                                                                value={prd.pass_sub_type}
                                                                error={error.pass_sub_type}
                                                                readOnly={true}
                                                                lable={searchTitle} />
                                                        </Col>
                                                        : ""}

                                                    {showEXP &&
                                                        <Col className='col-4 col-md-4 col-lg-4 mt-3'>
                                                            {/* <InputField
                                                                minLength={"0"}
                                                                name={"passexpiry"}
                                                                type={"number"}
                                                                value={prd.passexpiry}
                                                                error={error.passexpiry}
                                                                onChange={onHandler}
                                                                onFocus={() => {
                                                                    errorAlert("This change will apply only to new pass sales, not existing ones.");
                                                                }}
                                                                lable={"Days after purchase it expires"}
                                                            /> */}

                                                            <div className="mb-3">
                                                                <label htmlFor='passexpiry' className="form-label inputLable">Days after purchase it expires</label>
                                                                <input
                                                                    min={1}
                                                                    type="number"
                                                                    id="passexpiry"
                                                                    name="passexpiry"
                                                                    className="form-control"
                                                                    value={prd.passexpiry}
                                                                    onFocus={() => {
                                                                        infoAlert("This change will apply only to new pass sales, not existing ones.");
                                                                    }}
                                                                    onWheel={(e) => e.target.blur()}
                                                                    // onChange={(e) => {
                                                                    //     let value = e.target.value;

                                                                    //     // allow only digits
                                                                    //     if (!/^\d*$/.test(value)) {
                                                                    //         return;
                                                                    //     }

                                                                    //     // prevent 0 or negative
                                                                    //     if (value < 1) {
                                                                    //         value = 1;
                                                                    //     }

                                                                    //     onHandler({
                                                                    //         target: {
                                                                    //             name: "passexpiry",
                                                                    //             value: value
                                                                    //         }
                                                                    //     });
                                                                    // }}
                                                                    onChange={(e) => {
                                                                        let value = e.target.value;

                                                                        // allow only digits
                                                                        if (!/^\d*$/.test(value)) return;

                                                                        // allow empty (important for typing)
                                                                        if (value === "") {
                                                                            onHandler({
                                                                                target: {
                                                                                    name: "passexpiry",
                                                                                    value: ""
                                                                                }
                                                                            });
                                                                            return;
                                                                        }

                                                                        // convert to number
                                                                        let num = parseInt(value, 10);

                                                                        onHandler({
                                                                            target: {
                                                                                name: "passexpiry",
                                                                                value: num
                                                                            }
                                                                        });
                                                                    }}
                                                                    onKeyDown={(e) => {
                                                                        // block -, +, e
                                                                        if (["-", "+", "e", "E"].includes(e.key)) {
                                                                            e.preventDefault();
                                                                        }
                                                                    }}
                                                                />
                                                                <small className="text-danger">{error.passexpiry}</small>
                                                            </div>
                                                        </Col>}
                                                    {showRenew &&
                                                        <Col className='col-4 col-md-4 col-lg-4 mt-3'>
                                                            <InputField
                                                                minLength={"0"}
                                                                name={"passexpiry"}
                                                                type={"number"}
                                                                readOnly={true}
                                                                value={prd.passexpiry}
                                                                error={error.passexpiry}
                                                                onChange={onHandler}
                                                                lable={<><span>Days after purchase it </span><u>Renew</u></>} />
                                                        </Col>}

                                                    <Col className='col-4 col-md-4 col-lg-4 mt-3'>
                                                        <InputField
                                                            type={"date"}
                                                            name={"purchase_date"}
                                                            minLength={moment().format('YYYY-MM-DD')} // disables all dates before today
                                                            onChange={(e) => { setNewDate(e.target.value) }}
                                                            readOnly={
                                                                moment(prd.purchase_date).isSameOrBefore(moment(), 'day') // if future date → true (readonly)
                                                            }
                                                            value={moment(prd.purchase_date).format('YYYY-MM-DD')}
                                                            error={error.purchase_date}
                                                            lable={"Date available for purchase"}
                                                        />
                                                    </Col>

                                                    <Col className='col-6 col-md-6 col-lg-6 mt-3'>
                                                        <TextArea
                                                            name={"description"}
                                                            error={error.description}
                                                            value={prd.description}
                                                            onChange={onHandler}
                                                            lable={"Description"} />
                                                    </Col>
                                                    <Col className='col-6 col-md-6 col-lg-6 mt-3'>
                                                        <TextArea
                                                            name={"notes"}
                                                            error={error.notes}
                                                            value={prd.notes}
                                                            onChange={onHandler}
                                                            lable={"Notes"} />
                                                    </Col>

                                                    <Col className='col-4 col-md-4 col-lg-4 mt-3'>
                                                        <InputTypeTax
                                                            name={"amount"}
                                                            type={"number"}
                                                            value={prd.amount}
                                                            minLength={'0'}
                                                            error={error.amount}
                                                            readOnly={true}
                                                            lable={"Amount (In $)"} />
                                                    </Col>

                                                    <Col className='col-4 col-md-4 col-lg-4 mt-3'>
                                                        <SharedSelect
                                                            options={opyesno}
                                                            name={"tax1"}
                                                            value={(prd.tax1).toLowerCase()}
                                                            onChange={onHandler}
                                                            error={error.tax1}
                                                            lable={"Tax 1 Applicable"} />
                                                    </Col>
                                                    {(prd.tax1).toLowerCase() == "yes" ?
                                                        <Col className='col-4 col-md-4 col-lg-4 mt-3'>
                                                            <InputTypeTax
                                                                name={"tax1_rate"}
                                                                type={"number"}
                                                                value={prd.tax1_rate}
                                                                error={error.tax1_rate}
                                                                minLength={"0"}
                                                                onChange={onHandler}
                                                                lable={"Tax 1 Rate %"} />
                                                        </Col>
                                                        : ""}
                                                    <Col className='col-4 col-md-4 col-lg-4 mt-3'>
                                                        <SharedSelect
                                                            options={opyesno}
                                                            name={"tax2"}
                                                            value={(prd.tax2).toLowerCase()}
                                                            onChange={onHandler}
                                                            error={error.tax2}
                                                            lable={"Tax 2 Applicable"} />
                                                    </Col>

                                                    {(prd.tax2).toLowerCase() == "yes" ?
                                                        <Col className='col-4 col-md-4 col-lg-4 mt-3'>
                                                            <InputTypeTax
                                                                name={"tax2_rate"}
                                                                type={"number"}
                                                                value={prd.tax2_rate}
                                                                error={error.tax2_rate}
                                                                onChange={onHandler}
                                                                minLength={"0"}
                                                                lable={"Tax 2 Rate %"} />
                                                        </Col>
                                                        : ""}


                                                    <Col className='col-4 col-md-4 col-lg-4 mt-3'>
                                                        <SharedSelect
                                                            options={opyesno}
                                                            name={"is_client_visible"}
                                                            value={prd.is_client_visible}
                                                            error={error.is_client_visible}
                                                            onChange={onHandler}
                                                            lable={"Visible to client"} />
                                                    </Col>
                                                    <Col className='col-4 col-md-4 col-lg-4 mt-3'>
                                                        <SharedSelect
                                                            options={opyesno}
                                                            name={"is_one_time_purchase"}
                                                            value={prd.is_one_time_purchase}
                                                            error={error.is_one_time_purchase}
                                                            readOnly={true}
                                                            onChange={onHandler}
                                                            lable={"One time purchase only"} />
                                                    </Col>


                                                    {/* Auto Add Button */}
                                                    <Col className='col-4 col-md-4 col-lg-4 mt-3'>
                                                        {isAutoAdd ?
                                                            <>
                                                                <label className="form-label inputLable" style={{ display: 'flex', justifyContent: 'space-between' }}>
                                                                    <span>Auto Add</span>
                                                                    <span><Tooltips myPlacement={'left'} info={'Auto Add feature will automatically add this pass to new clients after they accept the T&C’s / Waiver and become a client. '} /></span>
                                                                </label>
                                                                <select
                                                                    className="form-select"
                                                                    name={'autoAdd'}
                                                                    aria-label="Default select example"
                                                                    onChange={onHandler}
                                                                    value={prd.autoAdd}
                                                                >
                                                                    {yesNoOption ? yesNoOption.map((option, index) => (
                                                                        <option key={index} value={option.value ? option.value : ''}>
                                                                            {option.label ? option.label : ""}
                                                                        </option>
                                                                    )) : ''}
                                                                </select>
                                                            </>
                                                            :
                                                            <>
                                                                <label className="form-label inputLable" style={{ display: 'flex', justifyContent: 'space-between' }}>
                                                                    <span>Auto Add</span>
                                                                    <span><Tooltips myPlacement={'left'} info={'Auto Add feature will automatically add this pass to new clients after they accept the T&C’s / Waiver and become a client. '} /></span>
                                                                </label>
                                                                <div style={{ position: 'relative' }}>
                                                                    <select disabled className="form-select">
                                                                        <option value="">Select</option>
                                                                    </select>
                                                                    <div
                                                                        onClick={() => errorAlert("Auto-add feature only works when pass price is set to 0")}
                                                                        style={{
                                                                            position: 'absolute',
                                                                            top: 0, left: 0,
                                                                            width: '100%', height: '100%',
                                                                            cursor: 'not-allowed'
                                                                        }}
                                                                    />
                                                                </div>

                                                            </>
                                                        }
                                                    </Col>

                                                    <Col className='col-4 col-md-4 col-lg-4 mt-3'>
                                                        <SharedSelect
                                                            options={ageOPT}
                                                            name={"age_restriction"}
                                                            value={prd.age_restriction}
                                                            error={error.age_restriction}
                                                            onChange={onHandler}
                                                            readOnly={true}
                                                            lable={"Age Restriction"} />
                                                    </Col>
                                                    {(prd.age_restriction).toLowerCase() != "none" ?
                                                        <Col className='col-4 col-md-4 col-lg-4 mt-4'>
                                                            <InputField
                                                                type={"number"}
                                                                minLength={"0"}
                                                                name={"age_over_under"}
                                                                value={prd.age_over_under}
                                                                readOnly={true}
                                                                error={error.age_over_under}
                                                                onChange={onHandler}
                                                                lable={"What age over/under"}
                                                            />
                                                        </Col>
                                                        : ""}

                                                    <Col className='col-4 col-md-4 col-lg-4 mt-4'>
                                                        <SharedMultiSelect
                                                            labelText="Add More Class"
                                                            setSkillsdata={setSkillsdata}
                                                            name="class_details"
                                                            options={classOption ? classOption : ""}
                                                        />

                                                    </Col>


                                                    {/* <Col className='col-4 col-md-4 col-lg-4 mt-4'>
                                                        <SharedSelect
                                                            options={statusOption}
                                                            name={"pass_status"}
                                                            value={prd.pass_status}
                                                            error={error.pass_status}
                                                            onChange={onHandler}
                                                            lable={"Pass Status"} />
                                                    </Col> */}


                                                    {/* Pass Status Active / InActive */}
                                                    <Col className='col-4 col-md-4 col-lg-4 mt-3'>
                                                        {!checkIsPurchase ?
                                                            <>
                                                                <label className="form-label inputLable" style={{ display: 'flex', justifyContent: 'space-between' }}>
                                                                    <span>Pass Status</span>
                                                                </label>
                                                                <select
                                                                    className="form-select"
                                                                    name={'pass_status'}
                                                                    onChange={onHandler}
                                                                    value={prd.pass_status}
                                                                >
                                                                    {statusOption ? statusOption.map((option, index) => (
                                                                        <option key={index} value={option.value ? option.value : ''}>
                                                                            {option.label ? option.label : ""}
                                                                        </option>
                                                                    )) : ''}
                                                                </select>
                                                            </>
                                                            :
                                                            <>
                                                                <label className="form-label inputLable" style={{ display: 'flex', justifyContent: 'space-between' }}>
                                                                    <span>Pass Status</span>
                                                                </label>
                                                                <div style={{ position: 'relative' }}>
                                                                    <select disabled className="form-select">
                                                                        <option value="">{prd.pass_status}</option>
                                                                    </select>
                                                                    <div
                                                                        onClick={() =>
                                                                            Swal.fire({
                                                                                html: `
                                                                                    <div style="text-align: left; font-size: 15px; line-height: 1.5;">
                                                                                    <p style="text-align:center">
                                                                                        This pass cannot be set to <b>Inactive</b> because some clients still have an active version of this pass.
                                                                                    </p>
                                                                                    <p style="text-align:center">
                                                                                        Run the <b>“Pass Purchase Report”</b> to view clients who currently hold this pass.
                                                                                    </p>
                                                                                    </div>
                                                                                `,
                                                                                showConfirmButton: true,
                                                                                confirmButtonText: 'OK',
                                                                                confirmButtonColor: '#28a745', // replace with your green hex code
                                                                                icon: null, // removes the question-circle icon
                                                                            })

                                                                        }
                                                                        style={{
                                                                            position: 'absolute',
                                                                            top: 0, left: 0,
                                                                            width: '100%', height: '100%',
                                                                            cursor: 'not-allowed'
                                                                        }}
                                                                    />
                                                                </div>

                                                            </>
                                                        }
                                                    </Col>

                                                </Row>
                                                <Row className="my-4">
                                                    <h3>Existing Class </h3>
                                                    <hr />

                                                    <div className="existingClassesText">
                                                        <ul>
                                                            <Row>
                                                                {classes && classes.class_id ? (classes.class_id).map((e, index) => (
                                                                    <Col lg={3} md={3} key={index}>
                                                                        <li>{e.class_name}</li>
                                                                    </Col>
                                                                )) : ""}
                                                            </Row>
                                                        </ul>
                                                    </div>

                                                </Row>

                                                <Row>

                                                    <Col></Col>
                                                    <Col></Col>
                                                </Row>

                                                <Row className="mt-3">
                                                    <Col>
                                                        <SharedButton
                                                            title={"Update"}
                                                            className={"btn btn-primary w-100"}
                                                            type={"submit"}
                                                            variant={"primary"}
                                                        />
                                                    </Col>
                                                    <Col>
                                                        <SharedButton
                                                            href={"/list-pass"}
                                                            title={"Back"}
                                                            className={"btn btn-outline w-100"}
                                                            type={"button"}
                                                            variant={"outline"}
                                                        />
                                                    </Col>
                                                    <Col></Col>
                                                </Row>
                                            </Form>
                                        </Container>
                                    </div>
                                </div>
                                <Footer />
                            </div>``
                        </Col>
                    </Row>
                </div>
            </div>
        </>
    );
};
